/* ==========================================================================
   CAND / PDP — Scripts das customizacoes da pagina de produto

   1. Auto-scroll da faixa de miniaturas no mobile
   2. Drawer "Saiba mais": FAQ "ver mais" e video sob demanda (fim do arquivo)

   Par: assets/pdp.css | Carregado em: layout/theme.liquid
   ========================================================================== */

/* ==========================================================================
   1. Auto-scroll da faixa de miniaturas no mobile

   O tema (theme.js > slideshow.childNavGoTo) decide o eixo de rolagem das
   miniaturas na inicializacao, a partir de data-position="beside" -> eixo Y.
   Como no mobile a faixa e horizontal (ver pdp.css), a
   miniatura ativa nunca entrava em vista ao deslizar a foto principal.

   Aqui observamos a classe .is-active que o tema aplica na miniatura atual
   e centralizamos ela no eixo X, sem tocar em theme.js.

   Par: assets/pdp.css
   Carregado em: layout/theme.liquid
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_MAX = 768;
  var SCROLLER = '.product__thumbs--scroller';
  var ACTIVE_THUMB = '.product__thumb.is-active';

  function centerThumb(scroller, thumb) {
    if (window.innerWidth > MOBILE_MAX) return;

    var item = thumb.closest('.product__thumb-item') || thumb;
    var itemRect = item.getBoundingClientRect();
    var scrollerRect = scroller.getBoundingClientRect();

    // Deslocamento necessario para centralizar a miniatura na faixa visivel.
    // Usa getBoundingClientRect (e nao offsetLeft) para nao depender de qual
    // elemento e o offsetParent, que muda entre os breakpoints.
    var delta =
      itemRect.left - scrollerRect.left - (scroller.clientWidth - itemRect.width) / 2;

    scroller.scrollLeft += delta;
  }

  function centerActive(scroller) {
    var thumb = scroller.querySelector(ACTIVE_THUMB);
    if (thumb) centerThumb(scroller, thumb);
  }

  function centerAll() {
    document.querySelectorAll(SCROLLER).forEach(centerActive);
  }

  // Um unico observer no documento cobre tambem galerias injetadas depois
  // (quick shop, recarga de secao no editor de temas).
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var el = mutations[i].target;

      if (el.nodeType !== 1 || !el.matches || !el.matches(ACTIVE_THUMB)) continue;

      var scroller = el.closest(SCROLLER);
      if (scroller) centerThumb(scroller, el);
      return;
    }
  });

  function start() {
    observer.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    centerAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Recentraliza ao girar o aparelho / cruzar o breakpoint
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(centerAll, 150);
  });
})();


/* ==========================================================================
   CAND / PDP — Drawer "Saiba mais": FAQ "ver mais" e video sob demanda

   O tema copia o HTML do gatilho para o <tool-tip> global com innerHTML,
   entao listeners presos aos elementos se perdem. Por isso tudo aqui e
   delegado no document e casa pelos data-attributes do markup em
   snippets/pdp-block-info-modal.liquid.

   - [data-pdp-faq-more]: mostra/esconde .pdp-faq__more (irmao dentro de .pdp-faq)
   - [data-pdp-video="ID"]: no clique, troca a capa pelo iframe do YouTube.
     Nada do YouTube e carregado antes disso.

   Par: assets/pdp.css (secao 6)
   ========================================================================== */

(function () {
  'use strict';

  function toggleFaq(button) {
    var faq = button.closest('.pdp-faq');
    var more = faq && faq.querySelector('.pdp-faq__more');
    if (!more) return;

    var willOpen = more.hidden;
    more.hidden = !willOpen;
    button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    button.textContent = willOpen
      ? (button.dataset.labelLess || 'Ver menos')
      : (button.dataset.labelMore || 'Ver mais');

    if (!willOpen) {
      // Ao recolher, garante que o usuario nao fique olhando um espaco vazio
      faq.scrollIntoView({ block: 'nearest' });
    }
  }

  function playVideo(box) {
    if (box.classList.contains('is-playing')) return;

    var id = box.dataset.pdpVideo;
    if (!id) return;

    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    iframe.title = box.getAttribute('aria-label') || 'Vídeo';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');

    box.classList.add('is-playing');
    box.appendChild(iframe);
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var faqButton = target.closest('[data-pdp-faq-more]');
    if (faqButton) {
      e.preventDefault();
      toggleFaq(faqButton);
      return;
    }

    var video = target.closest('[data-pdp-video]');
    if (video) {
      e.preventDefault();
      playVideo(video);
    }
  });
})();
